import { GenericError } from '@com-delta-idp/mnx-utils';

export interface FlightAwardSegment {
  airlineCode: string;
  baseMiles: number;
  destAirportCode: string;
  origAirportCode: string;
}

export interface FlightAwardDO {
  fltAwdSegments: FlightAwardSegment[];
  otherTktNums: string[];
  ticketNum: string;
}

export interface AccountActivity {
  activityDate: string;
  activityReasonCode: string;
  actyType: string;
  desc: string;
  flightAwardDO?: FlightAwardDO;
  ticketNum?: string;
  milesPlusCashMilesCopay?: number;
  milesPlusCashNetMiles?: number;
  milesPlusCashRevCopay?: number;
}

export interface TrackerErrorResponse {
  code: string;
  developerMessage: string;
  message: string;
  moreInfo?: GenericError[];
}

export interface AccountActivityInfo {
  accountActivities?: AccountActivity[];
  endDate?: string;
  flightAwardCount?: number;
  lastAirAwardActivityDate?: string;
  lastAirAwardPostDate?: string;
  lastAirAwardSequenceNumber?: string;
  lastAirMileageActivityDate?: string;
  lastAirMileageSequenceNumber?: string;
  lastNonAirMileageActivityDate?: string;
  lastNonAirMileageSequenceNumber?: string;
  loyaltyAccountNumber?: string;
  moreAirAwards?: string;
  moreAirMileage?: string;
  moreNonAirAwards?: string;
  moreNonAirMileage?: string;
  nonFlightAwardCount?: number;
  startDate?: string;
  errorResponse?: TrackerErrorResponse;
}

export interface SnapshotResponses {
  accountActivityInfoDO: AccountActivityInfo;
}

export interface RecentAccountActivity {
  activityDate: string;
  activityCode: string;
  activityType: string;
  origAirportCode?: string;
  destAirportCode?: string;
  activityDesc: string;
  totalMiles: number;
  totalMQD: string;
}

export interface RecentAccountActivityInfoDO {
  recentAccountActivities: RecentAccountActivity[];
  loyaltyAccountNumber: string;
}

export interface SnapshotResponse {
  recentAccountActivityInfoDO: RecentAccountActivityInfoDO;
}

export interface SnapshotRequest {
  carrierCode: string;
}
